'use client';

import { c as _c } from "react/compiler-runtime";
import { HousePerson, NavArrowDown } from '@byway/icons';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { DialogTrigger, Button as RACButton } from 'react-aria-components';
import { Popover } from '~/components/Popover';
import { ChangeOriginModal } from '~/components/TripOverview/booking/ChangeOriginModal';
import { useTripOriginUpdate } from '~/components/TripOverview/hooks/useTripOriginUpdate';
import { useIsDesktop } from '~/hooks/useIsDesktop';
import styles from './ChangeOriginButton.module.css';
type ChangeOriginButtonProps = {
  originName: string;
  tripId: string;
};
export function ChangeOriginButton(t0) {
  const $ = _c(41);
  const {
    originName,
    tripId
  } = t0;
  const t = useTranslations("journey");
  const tCommon = useTranslations("common");
  const isDesktop = useIsDesktop();
  const {
    confirmOrigin
  } = useTripOriginUpdate();
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HousePerson size="small" width={22} height={22} decorative={true} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== tCommon) {
    t2 = tCommon("change_origin");
    $[1] = tCommon;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== originName) {
    t3 = <strong>{originName}</strong>;
    $[3] = originName;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <span>{t2}: {t3}</span>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const t5 = isOpen ? `${styles.chevron} ${styles.chevronOpen}` : styles.chevron;
  let t6;
  if ($[8] !== t5) {
    t6 = <NavArrowDown decorative={true} size="small" className={t5} />;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t4 || $[11] !== t6) {
    t7 = <>{t1}{t4}{t6}</>;
    $[10] = t4;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const buttonContent = t7;
  if (isDesktop) {
    let t8;
    if ($[13] !== buttonContent) {
      t8 = <RACButton className={styles.originButton} data-test-id="change-origin-button">{buttonContent}</RACButton>;
      $[13] = buttonContent;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    let t9;
    if ($[15] !== t) {
      t9 = t("booking_choose_origin");
      $[15] = t;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    let t10;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = () => setIsOpen(false);
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    let t11;
    if ($[18] !== confirmOrigin || $[19] !== originName || $[20] !== tripId) {
      t11 = <ChangeOriginModal presentation="popover" isOpen={true} close={t10} currentOrigin={originName} tripId={tripId} onConfirm={confirmOrigin} />;
      $[18] = confirmOrigin;
      $[19] = originName;
      $[20] = tripId;
      $[21] = t11;
    } else {
      t11 = $[21];
    }
    let t12;
    if ($[22] !== t11 || $[23] !== t9) {
      t12 = <Popover placement="bottom start" isDismissable={true} ariaLabel={t9} maxWidth={320}>{t11}</Popover>;
      $[22] = t11;
      $[23] = t9;
      $[24] = t12;
    } else {
      t12 = $[24];
    }
    let t13;
    if ($[25] !== isOpen || $[26] !== t12 || $[27] !== t8) {
      t13 = <DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>{t8}{t12}</DialogTrigger>;
      $[25] = isOpen;
      $[26] = t12;
      $[27] = t8;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    return t13;
  }
  let t8;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setIsOpen(true);
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== buttonContent) {
    t9 = <button type="button" className={styles.originButton} data-test-id="change-origin-button" onClick={t8}>{buttonContent}</button>;
    $[30] = buttonContent;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  let t10;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = () => setIsOpen(false);
    $[32] = t10;
  } else {
    t10 = $[32];
  }
  let t11;
  if ($[33] !== confirmOrigin || $[34] !== isOpen || $[35] !== originName || $[36] !== tripId) {
    t11 = <ChangeOriginModal isOpen={isOpen} close={t10} currentOrigin={originName} tripId={tripId} onConfirm={confirmOrigin} />;
    $[33] = confirmOrigin;
    $[34] = isOpen;
    $[35] = originName;
    $[36] = tripId;
    $[37] = t11;
  } else {
    t11 = $[37];
  }
  let t12;
  if ($[38] !== t11 || $[39] !== t9) {
    t12 = <>{t9}{t11}</>;
    $[38] = t11;
    $[39] = t9;
    $[40] = t12;
  } else {
    t12 = $[40];
  }
  return t12;
}